import React from "react";
import { Outlet } from "react-router";
import NavLinker from "../../../components/NavLinker";

function RequestedLoans() {
  return (
    <div className="flex flex-col gap-2 bg-white rounded-xl shadow-md  p-4">
      <div className="w-full  flex gap-2 items-center rounded-md  px-4 pt-4">
        <NavLinker to="" end>
          <span className=" font-medium  ">Pending</span>
        </NavLinker>
        <NavLinker to="approved">
          <span className="font-medium  ">Approved</span>
        </NavLinker>
        <NavLinker to="rejected">
          <span className=" font-medium ">Rejected</span>
        </NavLinker>
      </div>
      <div>
        <Outlet />
      </div>
    </div>
  );
}

export default RequestedLoans;
